import { Fragment } from 'react';

import HomeAccordionItem from './accordionItem';
import Divider from '@com/_atoms/Divider';
import classNames from 'classnames';
import { defaultFaqData } from '@constant/faq';

interface data {
  id: number;
  question: string;
  answer: string;
}
interface IProps {
  hasTitle?: boolean;
  className?: string;
  data?: data[];
}

const FrequentQuestions = ({
  hasTitle = true,
  className,
  data = defaultFaqData,
}: IProps) => {
  return (
    <div className={classNames('mt-4', className)}>
      {data?.map((item, index) => (
        <Fragment key={item?.id}>
          <HomeAccordionItem
            key={item?.id}
            id={0}
            title={item?.question}
            value={item?.answer}
          />
          {index !== data?.length - 1 && <Divider />}
        </Fragment>
      ))}
    </div>
  );
};

export default FrequentQuestions;
